module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Export-09d81ccb79ed31832efacd4381bd618c.svg";